// ================ Action types ================ //

import { createBlogPost } from "../../util/api";

export const SET_INITIAL_VALUES = 'app/BlogPreviewPage/SET_INITIAL_VALUES';

export const SAVE_BLOG_DRAFT_REQUEST = 'app/BlogPreviewPage/SAVE_BLOG_DRAFT_REQUEST';
export const SAVE_BLOG_DRAFT_SUCCESS = 'app/BlogPreviewPage/SAVE_BLOG_DRAFT_SUCCESS';
export const SAVE_BLOG_DRAFT_ERROR = 'app/BlogPreviewPage/SAVE_BLOG_DRAFT_ERROR';

export const PUBLISH_BLOG_REQUEST = 'app/BlogPreviewPage/PUBLISH_BLOG_REQUEST';
export const PUBLISH_BLOG_SUCCESS = 'app/BlogPreviewPage/PUBLISH_BLOG_SUCCESS';
export const PUBLISH_BLOG_ERROR = 'app/BlogPreviewPage/PUBLISH_BLOG_ERROR';

export const REMOVE_BLOG = 'app/BlogPreviewPage/REMOVE_BLOG';
export const EDIT_BLOG = 'app/BlogPreviewPage/EDIT_BLOG';

// ================ Reducer ================ //

const initialState = {
    blogs: []
};

// ================ Reducer ================ //

const BlogPreviewPageReducer = (state = initialState, action) => {
    const { type, payload, error } = action;
    switch (type) {
        case SET_INITIAL_VALUES:
            return {
                ...state,
                blogs: payload,
            };

        case SAVE_BLOG_DRAFT_REQUEST:
            return { ...state, saveDraftInProgress: true, saveDraftError: null };
        case SAVE_BLOG_DRAFT_SUCCESS:
            return { ...state, saveDraftInProgress: false };
        case SAVE_BLOG_DRAFT_ERROR:
            return { ...state, saveDraftInProgress: false, saveDraftError: error };

        case PUBLISH_BLOG_REQUEST:
            return { ...state, publishInProgress: true, publishError: null };
        case PUBLISH_BLOG_SUCCESS:
            return { ...state, publishInProgress: false };
        case PUBLISH_BLOG_ERROR:
            return { ...state, publishInProgress: false, publishError: error };

        case REMOVE_BLOG:
            return { ...state, blogs: state.blogs.filter((_, idx) => idx !== payload) }
        case EDIT_BLOG:
            return {
                ...state,
                blogs: state.blogs.map((blog, idx) => idx === payload.index ? { ...blog, ...payload.blog } : blog)
            };
        default:
            return state;
    }
};

export default BlogPreviewPageReducer;



// ================ Action creators ================ //

export const editBlog = (index, blog) => ({ type: EDIT_BLOG, payload: { index, blog } });

export const setInitialValues = (blogs) => ({
    type: SET_INITIAL_VALUES,
    payload: blogs,
});

export const saveBlogDraftRequest = () => ({ type: SAVE_BLOG_DRAFT_REQUEST });
export const saveBlogDraftSuccess = (blog) => ({ type: SAVE_BLOG_DRAFT_SUCCESS, payload: blog });
export const saveBlogDraftError = (error) => ({ type: SAVE_BLOG_DRAFT_ERROR, error });

export const publishBlogRequest = () => ({ type: PUBLISH_BLOG_REQUEST });
export const publishBlogSuccess = (blog) => ({ type: PUBLISH_BLOG_SUCCESS, payload: blog });
export const publishBlogError = (error) => ({ type: PUBLISH_BLOG_ERROR, error });

export const removeBlog = (blogInd) => ({ type: REMOVE_BLOG, payload: blogInd })

// ================ Thunks ================ //
// Save blog as draft
export const saveBlogDraft = (blogData) => async dispatch => {
    dispatch(saveBlogDraftRequest());
    try {
        const locale = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'en';
        const response = await createBlogPost({ ...blogData, locale });
        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to save draft');
        dispatch(saveBlogDraftSuccess(data.data));
        return data.data;
    } catch (error) {
        dispatch(saveBlogDraftError(error.message));
    }
};

// Publish blog
export const publishBlog = (blogData) => async dispatch => {
    dispatch(publishBlogRequest());
    try {
        const locale = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'en';
        const response = await createBlogPost({ ...blogData, showInStore: true, locale });
        const data = await response.json();
        if (!data.success) throw new Error(data.error || 'Failed to publish blog');
        dispatch(publishBlogSuccess(data.data));
        return data.data;
    } catch (error) {
        dispatch(publishBlogError(error.message));
    }
};

// ================ Selectors ================ //
export const selectSaveDraftInProgress = state => state.BlogsPreviewPage.saveDraftInProgress;


